import { useApiClient } from "@/src/hooks/useApiClient";
import type { ReportStatus } from "@/src/pages/Reports/reports.type";

/**
 * On compte, on ne lit pas.
 *
 * `total` est un `count(*)` sur le statut, indépendant de `limit` : une seule
 * ligne suffit donc à connaître la taille de la file. Le serveur a corrigé ce
 * point — auparavant `total` valait la taille de la page renvoyée, et compter
 * imposait de rapatrier les deux cents cartes qu'on n'affichait pas.
 */
const COUNT_LIMIT = 1;

/** `undefined` tant que le serveur n'a pas répondu — pas `0`. */
export type ReportCounts = Record<ReportStatus, number | undefined>;

function useCount(status: ReportStatus) {
  const $api = useApiClient();

  const { data } = $api.useQuery("get", "/api/v1/moderation/reports", {
    params: { query: { status, limit: COUNT_LIMIT } },
  });

  return data?.data?.total;
}

/**
 * Le volume des trois files, pour les bascules.
 *
 * ⚠️ **Pas de `useQueryErrorToast` ici.** Un compteur muet est un désagrément ;
 * trois toasts qui doublent celui de la liste, sur la même panne et au même
 * instant, en est un plus grand. La file affichée porte déjà l'erreur et le
 * bouton pour réessayer.
 *
 * Les trois appels partagent le préfixe de clé
 * `["get", "/api/v1/moderation/reports"]` : l'invalidation qui suit un verdict
 * (cf. `useResolveReport`) les rafraîchit avec la liste, sans rien de plus.
 */
export function useReportCounts(): ReportCounts {
  return {
    pending: useCount("pending"),
    actioned: useCount("actioned"),
    dismissed: useCount("dismissed"),
  };
}
